import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';
import { whenOrganizationAccessResolved } from './organization-access';
import { AppUrls } from '../../routing/app-urls';

// no access to hotelGPT => user should not be here
export const hotelGptAccessGuard: CanActivateFn = () => {
    const applicationStore: ApplicationStoreType = inject(ApplicationStore);
    const router = inject(Router);

    return whenOrganizationAccessResolved(() =>
        applicationStore.hasHotelGptAccess() ? true : router.createUrlTree(['/', AppUrls.noAccessUrl]),
    );
};

export const dataDropAccessGuard: CanActivateFn = () => {
    const applicationStore: ApplicationStoreType = inject(ApplicationStore);
    const router = inject(Router);

    return whenOrganizationAccessResolved(() =>
        applicationStore.hasDataDropAccess() ? true : router.createUrlTree(['/', AppUrls.hotelGptUrl]),
    );
};
